import { useContext } from "react"
import { AuthContext } from "../context/auth"

export default function useEmail() {
    const { email } = useContext(AuthContext)
    return email ? email : "anonymous"
}
